'use client';

import { type FC, useEffect, useRef, useState } from 'react';
import { ChevronDown, ChevronUp } from '@eqi-investimentos/icons/web';
import { Flex, IconButton } from '@eqi-investimentos/react';

export const ButtonScrollVerticalModeText: FC<
  ButtonScrollVerticalModeTextProps
> = ({ containerId }) => {
  const containerRef = useRef<HTMLElement | null>(null);

  const [isMounted, setIsMounted] = useState(false);

  const scrollUp = () =>
    containerRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

  const scrollDown = () =>
    containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });

  useEffect(() => {
    setTimeout(() => {
      containerRef.current = document.getElementById(containerId);
      setIsMounted(true);
    }, 1000);
  }, [containerId]);

  if (!isMounted) return <></>;

  return (
    <Flex
      position="sticky"
      h="fit-content"
      top="16rem"
      transform="translateY(-50%)"
      direction="column"
      gap="s"
    >
      <IconButton
        id="button-scroll-up-read-news"
        aria-label="Subir página"
        icon={<ChevronUp boxSize="1.5rem" color="content.brand" />}
        onClick={scrollUp}
        {...buttonProps}
      />
      <IconButton
        id="button-scroll-down-read-news"
        aria-label="Descer página"
        icon={<ChevronDown boxSize="1.5rem" color="content.brand" />}
        onClick={scrollDown}
        {...buttonProps}
      />
    </Flex>
  );
};

const buttonProps = {
  borderRadius: 'full',
  boxSize: '2.75rem',
  bg: 'transparency.mid',
  variant: 'ghost',
  _hover: { bg: 'action.hover.brandLight' },
};

type ButtonScrollVerticalModeTextProps = {
  containerId: string;
};
